module.exports = __webpack_public_path__ + "img/409.1620eb5e.png";